const Logout = () => {
  return <div style={{ padding: "10px" }}>Logout</div>;
};

export default Logout;
